import { render, staticRenderFns } from "./BaseRegistrationForBusinessUser.vue?vue&type=template&id=1356c86b&"
import script from "./BaseRegistrationForBusinessUser.vue?vue&type=script&lang=js&"
export * from "./BaseRegistrationForBusinessUser.vue?vue&type=script&lang=js&"
import style0 from "./BaseRegistrationForBusinessUser.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports